<template>
  <div class="my-hours">

    <div class="columns">
      <div class="column">
        <h1 class="title is-4">{{ user.firstName }} {{ user.lastName }}</h1>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <week-select @week-changed="onWeekChanged" />
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <employee-hours :user="user" :week="week" />
      </div>
    </div>

  </div>
</template>
<script>
import WeekSelect from '../components/WeekSelect'
import EmployeeHours from '../components/EmployeeHours'
export default {
  name: 'MyHours',
  components: {
    WeekSelect,
    EmployeeHours
  },
  data () {
    return {
      week: null
    }
  },
  computed: {
    user () { return this.$store.getters.user }
  },
  methods: {
    onWeekChanged (week) {
      this.week = week
    }
  }
}
</script>
